import app from "./app";
import server from "./server";

const values = {
  app,
  server,
};

export default values;
